import { useSelector } from 'react-redux';
import StageTracker from '../components/StageTracker';
import MobileStepStatus from '../components/MobileStepStatus';
import RegisterNewTestPage from './RegisterNewTest';

export default function ActivateBarcode() {
  const showPasswordStep = useSelector((state) => state.user.show_password_step === true);
  const activeStep = showPasswordStep ? 4 : 3;

  return (
    <div className="w-full bg-white h-auto flex flex-col overflow-hidden overflow-x-hidden relative">
      <div className="w-full max-w-[1920px] mx-auto flex-1 min-h-0 flex flex-col lg:flex-row px-4 sm:px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-40 gap-4 lg:gap-8 items-stretch py-8 md:py-6">
        <div className="hidden lg:flex lg:w-1/2 lg:min-h-0 lg:flex-shrink-0 relative overflow-hidden rounded-3xl bg-[#F9F5F2]">
          <div className="relative z-10 flex flex-col justify-start p-8 md:p-12 lg:p-14 w-full min-h-0 flex-1">
            <StageTracker activeStep={activeStep} showPasswordStep={showPasswordStep} />
          </div>
        </div>

        <div className="w-full min-w-0 lg:w-1/2 lg:min-h-0 lg:flex-shrink-0 flex flex-col items-center justify-center lg:items-end lg:justify-center overflow-hidden">
          <MobileStepStatus activeStep={activeStep} showPasswordStep={showPasswordStep} />
          <RegisterNewTestPage embedded />
          {/*
            Real activation UI fallback:
            <ActivateBarcodeCard />
          */}
        </div>
      </div>
    </div>
  );
}
